module.exports = "<div class=\"fourohfour center\">\n  <h3 class=\"uppercase\">\n    Oops 404...\n  </h3>\n  <button ui-sref=\"app.sales\" class=\"btn btn-primary\" ng-if=\"isLoggedIn\">\n    Back to dashboard\n  </button>\n  <button ui-sref=\"login\" class=\"btn btn-primary\" ng-if=\"!isLoggedIn\">\n    Back to login\n  </button>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/components/404/404.html
// module id = 541
// module chunks = 1